import { FrontEndSearchService } from './api/FrontEndSearchService'
import { SearchModelData } from './models/SearchModel'

const SearchModule = {
  namespaced: true,
  state: SearchModelData(),
  getters: {
    fetchAdvanceSearchList: state => state.advanceSearchList,
    fetchTextSearchList: state => state.textSearchList,
    fetchCheckBookMarkSearchAPI: state => state.checkBookMarkSearchAPI
  },
  mutations: {
    setAdvanceSearchList (state, data) {
      state.advanceSearchList = data.list
    },
    setTextSearchList (state, data) {
      state.textSearchList = data.list
    },
    setCheckBookMarkSearchAPI (state, data) {
      state.checkBookMarkSearchAPI = data
    }
  },
  actions: {
    /**
     * Get advanceSearch list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    advanceSearch ({ commit }, { resolve, reject, formData }) {
      try {
        const response = FrontEndSearchService.fetchAdvanceSearchList(formData)
        const { success, data } = response.data
        if (success === true) {
          commit('setAdvanceSearchList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setAdvanceSearchList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * Get textSearch list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async textSearch ({ commit }, { resolve, reject, searchString, filterId }) {
      try {
        const response = await FrontEndSearchService.fetchTextSearchList(searchString, filterId)
        const { success, data } = response.data
        if (success === true) {
          commit('setTextSearchList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setTextSearchList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * Get TextSearched list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async getTextSearchedItem ({ commit }, { resolve, reject, formData }) {
      try {
        const response = await FrontEndSearchService.fetchTextSearchedList(formData)
        const { success, data } = response.data
        if (success === true) {
          commit('setTextSearchList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setTextSearchList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * Get Books list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async fetchBooksOnLoad ({ commit }, { resolve, reject, formData }) {
      try {
        const response = await FrontEndSearchService.fetchBooksOnLoad(formData)
        const { success, data } = response.data
        if (success === true) {
          commit('setAdvanceSearchList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setAdvanceSearchList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async isLocationPresent ({ commit }, { resolve, reject, checkData }) {
      try {
        const response = await FrontEndSearchService.isLocationPresent(checkData)
        const { success, data } = response.data
        if (success === true) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    }
  }
}
export default SearchModule
